import { memo } from 'react';
import styled from 'styled-components';

import { formatPrimaryAppointmentWithDuration } from '@front/common/src/utils/appointment';
import colors from '@front/common/src/utils/colors';
import { toRem } from '@front/common/src/utils/styles';

import { translate } from '@front/i18n';

import Accordion from '@front/web-ui/src/components/accordion/accordion';
import Text from '@front/web-ui/src/components/base-text/variants/text';
import Separator from '@front/web-ui/src/components/separator/separator';

import useBasketSection from '../../../../../hooks/use-basket-section';
import { route, SPOT_APPOINTMENT_PATH } from '../../../../../steps/steps';
import type { ChildcareBasketProps } from '../../childcare-basket';

const t = translate('basket');

const StyledAccordion = styled(Accordion)`
  margin: ${toRem(20)} 0;
`;

type AppointmentSchedulesProps = Pick<ChildcareBasketProps, 'appointment' | 'duration'>;

const AppointmentSchedules = ({ appointment, duration }: AppointmentSchedulesProps) => {
  const title =
    appointment && duration
      ? formatPrimaryAppointmentWithDuration(appointment.primary, duration)
      : t('.primary_appointment.title.default');

  const { isOpen, isVisible, hasData } = useBasketSection({
    data: !!appointment && !!duration,
    sectionLocations: [route(SPOT_APPOINTMENT_PATH)],
  });

  if (!isVisible) return null;

  return (
    <>
      <Separator />
      <StyledAccordion
        icon='clock-filled'
        iconLabel={t('.appointment_icon_label')}
        title={title}
        isOpen={isOpen}
        withToggle={!hasData}
      >
        {!hasData && <Text.SM color={colors.ink50}>{t('.no_appointment_yet')}</Text.SM>}
      </StyledAccordion>
    </>
  );
};

export default memo(AppointmentSchedules);
